export enum EnvType {
    dev = "DEV",
    uat = "UAT",
    pro = "PRO"
}

export const AppConfig = {
    envType: EnvType.dev,
    buildDate: "2023-02-13 21:30",
}

export const isDebug = (AppConfig.envType !== EnvType.pro)
